import template from "./entity-classifications-viewer.html";

export default angular.module("vesl.components.entity-classifications-viewer", [])
	.component("entityClassificationsViewer", {
		template,
		bindings: {
			classifications: "<"
		}
	})
	.name;
